import { gkApi } from './index';

const barDeliveryApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    listBarDeliveries: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/bar-delivery/`,
        method: 'get',
        params: { limit: 500 },
      }),
      providesTags: ['BAR_DELIVERY_LIST'],
    }),
    listOpenBarDeliveries: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/bar-delivery/open/`,
        method: 'get',
        params: { limit: 500 },
      }),
      providesTags: ['BAR_DELIVERY_LIST'],
    }),
    getBarDeliveryDetails: builder.query({
      query: (deliveryId) => ({
        url: `/bar-delivery/${deliveryId}/`,
        method: 'get',
      }),
      providesTags: ['BAR_DELIVERY'],
    }),
    // Lazy (fired on click) so opening a delivery doesn't render a PDF nobody
    // asked for. 'blob' is NOT a valid responseHandler string — RTK only knows
    // 'json'/'text'/'content-type' and falls back to text() — so the handler
    // must be a function to actually get a Blob back. Tagged BAR_DELIVERY so
    // confirming or cancelling drops the stale copy, which prints without the
    // red "KOPIE!" banner.
    getBarDeliveryPdf: builder.query({
      query: (deliveryId) => ({
        url: `/bar-delivery/${deliveryId}/pdf/`,
        method: 'get',
        responseHandler: (response) => response.blob(),
      }),
      providesTags: ['BAR_DELIVERY'],
    }),
    createBarDelivery: builder.mutation({
      query: (payload) => ({
        url: '/bar-delivery/',
        method: 'post',
        body: payload,
      }),
      invalidatesTags: ['BAR_DELIVERY_LIST', 'STOCK'],
    }),
    confirmBarDelivery: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/bar-delivery/${id}/confirm/`,
        method: 'post',
        body: payload,
      }),
      invalidatesTags: ['BAR_DELIVERY_LIST', 'BAR_DELIVERY', 'STOCK'],
    }),
    cancelBarDelivery: builder.mutation({
      query: ({ id }) => ({
        url: `/bar-delivery/${id}/cancel/`,
        method: 'post',
      }),
      invalidatesTags: ['BAR_DELIVERY_LIST', 'BAR_DELIVERY', 'STOCK'],
    }),

    // --- Reporting ---
    getBarBillingReport: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/report/bar-billing/`,
        method: 'get',
      }),
      providesTags: ['BAR_DELIVERY_LIST'],
    }),
    // Lazy + blob responseHandler so it fires on click and returns a Blob
    // (same pattern as getDeliveryReportExcel in locationApi.js).
    getBarBillingReportExcel: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/report/bar-billing/excel/`,
        method: 'get',
        responseHandler: (response) => response.blob(),
      }),
    }),
    getBarDepositOverview: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/report/bar-deposit/`,
        method: 'get',
      }),
      providesTags: ['BAR_DELIVERY_LIST'],
    }),
    getBarLocationReport: builder.query({
      query: (locationId) => ({
        url: `/bar-location/report/${locationId}/`,
        method: 'get',
      }),
      providesTags: ['BAR_DELIVERY_LIST'],
    }),
  }),
});

export const {
  useListBarDeliveriesQuery,
  useListOpenBarDeliveriesQuery,
  useGetBarDeliveryDetailsQuery,
  useLazyGetBarDeliveryPdfQuery,
  useCreateBarDeliveryMutation,
  useConfirmBarDeliveryMutation,
  useCancelBarDeliveryMutation,
  useGetBarBillingReportQuery,
  useLazyGetBarBillingReportExcelQuery,
  useGetBarDepositOverviewQuery,
  useGetBarLocationReportQuery,
} = barDeliveryApi;
